function Footer() {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-logo">
                    <i className="fas fa-play-circle"></i>
                    <span>DinoShort</span>
                </div>
                <p className="footer-text">Copyright © 2025 DinoShort. All rights reserved.</p>
            </div>
        </footer>
    );
}

export default Footer;
